<template>
  <cso-button modifier="light-white"
              class="redesign-print-button"
              :disabled="!isEnabled"
              :label="$t(label || 'general.print')"
              icon="vf-icon-nb_print_rgb"
              :icon-alt-text="$t(label || 'general.print')"
              :data-cy="cypressName"
              @click="onPrint">
  </cso-button>
</template>
<script>
export default {
  name: 'CsoRedesignPrintButton',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    isEnabled: {
      type: Boolean,
      default: true
    },
    cypressName: {
      type: String,
      required: false,
      default: 'print-btn'
    }
  },
  methods: {
    onPrint () {
      if (this.isEnabled) {
        window.print()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
button {
  margin: 20px 0;

  @include xs {
    width: 100%;
  }
}
</style>
